<template>
  <div class="flex items-center justify-center mx-auto mt-10 font-sans auth">
    <amplify-authenticator username-alias="email">
      <amplify-sign-up
        slot="sign-up"
        username-alias="email"
        :form-fields.prop="formFields"
      ></amplify-sign-up>
      <amplify-sign-in slot="sign-in" username-alias="email"></amplify-sign-in>
    </amplify-authenticator>
  </div>
</template>

<script>
import { Hub } from 'aws-amplify';

export default {
  name: 'Auth',
  beforeCreate() {
    Hub.listen('auth', (data) => {
      const { payload } = data;
      if (payload.event === 'signIn') {
        this.$router.push('/');
      }
      if (payload.event === 'signOut') {
        this.$router.push('/auth');
      }
    });
  },
  data() {
    return {
      formFields: [
        {
          type: 'email',
          required: true,
        },
        {
          type: 'password',
          required: true,
        },
      ],
    };
  },
};
</script>

<style>
:root {
  --amplify-font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',
    'Segoe UI Symbol', 'Noto Color Emoji';
}
</style>
